<!--省市区三级联动-->
<template>
  <el-cascader :options="cascaderAreaData" :props="CascaderProps" v-model="data" clearable style="width: 100%;"/>
</template>

<script setup>
// import {pcaTextArr} from 'element-china-area-data'
//改成和手机端一样的数据源，不然数据不一致
import { useCascaderAreaData } from '@vant/area-data';

const cascaderAreaData=useCascaderAreaData()
const CascaderProps = {
  value: 'text',
  label: 'text',
  children: 'children',
}

const data = defineModel()
</script>

<style scoped lang="scss">

</style>